import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class QuestionCollectionsOrganizationsCountries extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'QuestionCollectionsOrganizationsCountries'
  // Define default properties here
  static instanceDefaults () {
    return {
      questionCollectionsOrganizationsId: 1,
      countryId: 1,
    }
  }
}
const servicePath = 'question-collections-organizations-countries'
const servicePlugin = makeServicePlugin({
  Model: QuestionCollectionsOrganizationsCountries,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
